import React, { useEffect, useState } from 'react';
import { Map } from '../Map/Map';
import Image from 'next/image';
import { LoadingSpinner } from '../../../shared-components/LoadingSpinner/LoadingSpinner';
import Pagination from '../../../shared-components/Pagination/Pagination';
import { AttractionTopTips } from '../AttractionTopTips/AttractionTopTips';
import { FaqSection } from '../FaqSection/FaqSection';
import { RelatedBreadcrumbLinks } from '../RelatedBreadcrumbLinks/RelatedBreadcrumbLinks';
import Footer from '../../../layouts/Footer/footer';
import Newsletter from '../../../layouts/Newsletter/Newsletter';
import {
  EAttractionCardPageType,
  ThingsTodoMobileProps
} from '../../../types/components/attraction-card';
import scrollToElement from '../../../utils/scrollIntoView';
import { ToastContainer } from 'react-toastify';
import AttractionCard from '../../../shared-components/AttractionCard/AttractionCard';

export const MobileView = ({
  attractionData,
  setAttractionData,
  thingsToDoDetails,
  showFullMap,
  topTips,
  radius,
  setRadius,
  mapRef,
  paginatedAttractionData,
  currentPage,
  attractionsPerPage,
  handlePageChange
}: ThingsTodoMobileProps) => {
  const [expanded, setExpanded] = useState(false);
  const [showMapButton, setShowMapButton] = useState(false);
  const [attractionCardsVisible, setAttractionsCardsVisible] = useState(false);

  // Hide Show Map Button when we are out of attractions Div
  useEffect(() => {
    const handleScroll = () => {
      const attractionsSection = document.getElementById('attractions-card');

      if (attractionsSection) {
        const rect = attractionsSection.getBoundingClientRect();

        if (paginatedAttractionData.length == 1 && rect.bottom <= 574) {
          setShowMapButton(false);
        } else if (
          (paginatedAttractionData.length == 0 ||
            paginatedAttractionData.length == 1) &&
          rect.bottom > 400
        ) {
          setShowMapButton(true);
        } else {
          const isInView = rect.bottom > window.innerHeight;

          setAttractionsCardsVisible(isInView);
          setShowMapButton(isInView);
        }
      }
    };

    const sliderDiv = document.getElementById('sliderDiv');
    if (sliderDiv) {
      sliderDiv.addEventListener('scroll', handleScroll);
      return () => {
        sliderDiv.removeEventListener('scroll', handleScroll);
      };
    }
  }, [expanded]);

  useEffect(() => {
    if (!expanded) {
      scrollToElement('attractions-card');
    }
  }, [attractionData]);

  // For Slideup/SlideDown mobile Attractions Card
  const toggleExpand = () => {
    setExpanded(prevExpanded => !prevExpanded);
    setShowMapButton(attractionCardsVisible);
  };

  const totalPages =
    (attractionData && Math.ceil(attractionData.length / attractionsPerPage)) ||
    0;

  useEffect(() => {
    scrollToElement('attractions-card');
  }, [currentPage]);

  return (
    <div className="flex flex-col relative h-[calc(100vh-180px)]">
      <Map
        attractionData={attractionData}
        setAttractionData={setAttractionData}
        thingsToDoDetails={thingsToDoDetails}
        showFullMap={showFullMap}
        radius={radius}
        setRadius={setRadius}
        mapRef={mapRef}
        pageType={EAttractionCardPageType.THINGS_TODO_PAGE}
      />

      <div
        className={`bg-white rounded-tl-[33px] rounded-tr-[33px] flex flex-col items-center w-full fixed z-[1000] transition-all duration-500 ease-in-out touch-pan-up ${
          expanded ? 'h-[calc(100vh-180px)] bottom-0' : 'h-[85px] bottom-[80px]'
        }`}
      >
        <p
          className={`text-base leading-7 font-normal py-5 flex flex-col gap-3 items-center `}
          onTouchStart={toggleExpand}
        >
          <div
            className={`${
              expanded ? `h-1.5` : `h-1.5`
            } w-[105px] bg-black13 opacity-[0.6] rounded-full`}
            onClick={toggleExpand}
          ></div>

          {attractionData ? (
            <p>{`Over ${attractionData.length} Attraction${
              attractionData?.length == 1 ? '' : 's'
            } within map area`}</p>
          ) : (
            <div className="h-3 w-32 bg-gray-300 rounded-full animate-pulse mt-2"></div>
          )}
        </p>
        <div
          className="grid grid-cols-1 gap-[18px] h-[1050px] overflow-y-scroll no-scrollbar"
          id="sliderDiv"
        >
          <div id="attractions-card">
            {attractionData === undefined ? (
              <div className="flex items-center justify-center h-[550px] flex-col gap-10">
                <LoadingSpinner className="w-8 h-8" />
              </div>
            ) : paginatedAttractionData.length === 0 ? (
              <div
                className="flex items-center justify-center xxsm:h-[350px] sm:h-[550px] flex-col gap-10 px-10 xxsm:mt-10 sm:mt-0"
                id="attractions-card"
              >
                <Image
                  src="https://res.cloudinary.com/see-sight-tours/image/upload/v1709532363/Remaining%20images/Attraction/ekhp3i11sp3dsr7e2poi.png"
                  alt="no-attractions-image"
                  width={300}
                  height={300}
                  className="xxsm:w-[70%] sm:w-full"
                />
                <p className="text-base font-normal text-center">
                  Currently no attractions available
                </p>
              </div>
            ) : (
              <div className="grid grid-cols-1  mmsm:grid-cols-2 xl:grid-cols-3 gap-[18px] xxsm:px-8  xsm:px-11 msm:px-6">
                {paginatedAttractionData.map((cardDetails, index) => (
                  <AttractionCard
                    attractionCard={cardDetails}
                    key={cardDetails.id}
                    index={(currentPage - 1) * attractionsPerPage + index + 1}
                    isMapCard={false}
                    pageType={EAttractionCardPageType.THINGS_TODO_PAGE}
                  />
                ))}
              </div>
            )}

            {expanded && showMapButton && (
              <div
                className={`absolute ${
                  paginatedAttractionData.length > 1
                    ? `bottom-24`
                    : paginatedAttractionData.length == 1
                    ? `bottom-[9rem] msm:bottom-[20rem] z-0`
                    : `top-24`
                } left-1/2 transform -translate-x-1/2 transition-all duration-500 ease-in-out`}
              >
                <button
                  className={` ${
                    paginatedAttractionData.length == 0
                      ? `bg-[#ffeaed] xxsm:border xxsm:border-[#222]  xxsm:text-[#222]`
                      : `bg-[#222] text-white`
                  }    text-base leadin-[18px] px-5 py-2.5 rounded-full flex items-center h-[42px]`}
                  onClick={toggleExpand}
                >
                  {paginatedAttractionData.length === 0 ? (
                    <Image
                      src="/red-show-map-icon.svg"
                      alt="map-icon"
                      width={18}
                      height={18}
                      className="mr-2"
                    />
                  ) : (
                    <Image
                      src="/map-icon.svg"
                      alt="map-icon"
                      width={18}
                      height={18}
                      className="mr-2"
                    />
                  )}
                  Show Map
                </button>
              </div>
            )}
            {totalPages > 1 && expanded && (
              <Pagination
                totalPages={totalPages}
                currentPage={currentPage}
                handlePageChange={page => handlePageChange(page)}
              />
            )}
          </div>
          <div
            className={`flex flex-col gap-8 ${
              totalPages > 1 ? 'mt-0' : 'mt-6'
            } z-10 bg-white`}
          >
            {/* <TrendingIdeas trending={thingsToDoDetails?.trending} /> */}

            {/* {thingsToDoDetails.products && (
              <TopTours thingsToDoDetails={thingsToDoDetails} />
            )} */}

            {/* <NeedToKnow
              description={thingsToDoDetails.need_to_know}
              cardItems={thingsToDoDetails.need_to_know_items}
            /> */}
            {topTips && <AttractionTopTips topTips={topTips} />}

            {thingsToDoDetails.faqs && (
              <FaqSection faqs={thingsToDoDetails.faqs} />
            )}

            {thingsToDoDetails.related_urls && (
              <RelatedBreadcrumbLinks
                breadcrumbs={thingsToDoDetails.related_urls}
              />
            )}

            <Newsletter />

            <Footer />

            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              limit={1}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
